import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Configuration from "@/features/settings/configuration";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration",
)({
  component: ConfigurationPage,
});

function ConfigurationPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex flex-col mb-5 w-full">
        <div className="font-bold text-xl mb-5">{t("configuration.title")}</div>
        <Configuration />
      </div>
    </div>
  );
}
